export default "__VITE_ASSET__B33lCdMA__"